var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "first_plate" }, [
      _c("div", { staticClass: "user_info" }, [
        _vm.accountInfoVO.userType === 1
          ? _c("img", {
              staticClass: "user_photo",
              attrs: {
                src:
                  _vm.loginUser && _vm.loginUser.imgPath && !_vm.isInDingTalk
                    ? _vm.fileOperShow(_vm.loginUser.imgPath)
                    : "",
                onerror: "this.src='/images/web/login_enterprise_icon.png'",
                alt: ""
              }
            })
          : _c("img", {
              staticClass: "user_photo",
              attrs: {
                src:
                  _vm.loginUser && _vm.loginUser.imgPath && !_vm.isInDingTalk
                    ? _vm.fileOperShow(_vm.loginUser.imgPath)
                    : "",
                onerror: "this.src='/images/web/login_user_icon.png'",
                alt: ""
              }
            }),
        _c("div", { staticClass: "user_msg" }, [
          _c("p", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.dingInfo ? _vm.dingInfo.dingTalkCorpName : " "))
          ]),
          _vm._m(0)
        ])
      ]),
      _vm._m(1),
      _c("div", { staticClass: "recharge_btn_box" }, [
        _vm._m(2),
        _c(
          "div",
          {
            staticClass: "recharge_btn",
            attrs: { tabindex: "0", hidefocus: true }
          },
          [
            _c("i", { staticClass: "el-icon-coin recharge_icon" }),
            _vm._v("\n        去充值\n      ")
          ]
        ),
        !_vm.isInDingTalk && _vm.showChangeAccount
          ? _c(
              "div",
              { staticClass: "change-account-sty" },
              [
                _c("change-account", {
                  attrs: {
                    justSwitching: true,
                    users: _vm.consoleUsers,
                    lineHeight: 59
                  },
                  on: { showExpandIcon: function() {}, justCall: _vm.pointCall }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]),
    _c("div", { staticClass: "product_notice" }, [
      _c(
        "div",
        { class: ["assets_system", { not_dingding: !_vm.isInDingTalk }] },
        [
          _c("img", {
            staticClass: "imgs",
            attrs: {
              src: require("../../../static/images/web/home/dingding_sys_img.png"),
              alt: ""
            }
          })
        ]
      ),
      _c(
        "div",
        { class: ["notice_content", { big_ul_bottom: _vm.noticeLengthCom }] },
        [
          _c(
            "ul",
            { staticClass: "notice_list" },
            _vm._l(_vm.ddNoticList, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: [
                    "notice_li",
                    { big_top: _vm.noticeLengthCom, ding_top: _vm.isInDingTalk }
                  ]
                },
                [
                  _c("div", { staticClass: "inline_block" }, [
                    _c("img", {
                      staticClass: "question_icon",
                      attrs: {
                        src: require("../../../static/images/home/question.png"),
                        alt: ""
                      }
                    }),
                    _c("span", [_vm._v(_vm._s(item.title))])
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    ]),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "not_real_name" }, [
      _c("p", { staticClass: "not_real_name_btn" }, [
        _c("img", {
          staticClass: "img",
          attrs: {
            src: require("../../../static/images/home/no_real_name.png"),
            alt: ""
          }
        }),
        _vm._v("\n            未实名\n            "),
        _c("span", [_vm._v("去认证")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "integral" }, [
      _c("div", { staticClass: "intergral_text" }, [
        _vm._v("\n        套餐剩余\n        "),
        _c("span", { staticClass: "span" }, [_vm._v("10 份合同")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "recharge_btn" }, [
      _c("i", {
        staticClass: "el-icon-setting recharge_icon",
        staticStyle: { "vertical-align": "text-bottom" }
      }),
      _vm._v("\n        控制台\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "advertisement_box" }, [
      _c("h3", [_vm._v("君子签优惠活动火热进行中！")]),
      _c("h4", [_vm._v("若您想了解具体政策，欢迎随时联系客服咨询详情。")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-378f6818", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-378f6818","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/login/components/bannerList.vue
// module id = RMgq
// module chunks = 87 131